import React, {useEffect, useState} from "react";
import {FormGroup, Page, PendingButton, required, SubmitButton,} from "components/common";

import {actions, Control, Errors} from "react-redux-form";
import {NotificationManager} from "react-notifications";
import {useForm} from "hooks";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";
import {Trans} from "react-i18next";
import {Table, Alert } from "reactstrap";
import {filter} from "lodash";
import {validationMessage} from "constants/validationMsg";
import {isCurrency} from "../../../services/util";
import BackButton from "../../../components/refactoring/BackButton";
import { convertTypes } from "pages/Payroll/Provisions/Edit";
import { HistoryAndNotes } from "components";

export const EditDeduction = ({
    client,
    payroll,
    t,
    url = "deductions",
    model = "local",
    history,
    match,
  }) => {
  let newDeductions = [];
  const {id} = match.params;
  const multiSelectStyle = {
    chips: { background: '#72B566' }, 
  }
  const {dispatch, setValue, value, Form, save, loaded, load, getTitle} =
    useForm({
      model,
    });
  const [amountTypesOptions, setAmountTypesOptions] = useState([]);
  const [allowanceRulesOptions, setAllowanceRulesOptions] = useState([]);
  const [deductions, setDeductions] = useState([]);
  const [settingsMessage, setSettingsMessage] = useState('');

  const onMount = async () => {
    const amountTypes = await client.get("amount_types").get("data");
    const allowanceRules = await payroll.get("allowance_rules_options").get("data");
    setAmountTypesOptions(convertTypes(amountTypes, t));
    setAllowanceRulesOptions(allowanceRules);
  };
  const handleSelect = (selectedList) => {
    setValue({...value, apply_to_allowances:selectedList});
  };

  const handleRemove = (selectedList) => {
    setValue({...value, apply_to_allowances:selectedList});
  };
  useEffect(() => void onMount(), []);
  useEffect(() => {
    async function fetchData() {
      const item = await load(payroll, url, id, {
        description: "",
        amount: "",
        amount_type: "",
        amount_type_display: "",
        apply_to_employees: [
          { name: 'Foreigner', value: false },
          { name: 'Local', value: false }
        ],
        apply_to_allowances: [],
      });
      setValue(item);
    }

    fetchData();
  }, [id]);

  async function onDeleteItem(deletedItem) {
    await payroll.delete(`${url}/${deletedItem}`);
    const availableDeduction = filter(value.deductions, (i) => i.id !== deletedItem)
    setDeductions(availableDeduction);
    setValue({...value, deductions: availableDeduction});
  }

  async function onSubmit(item) {
    item = {
      ...item,
      apply_to_allowances: item.apply_to_allowances.map((i)=> i.id),
    }
    try {
      dispatch(actions.setPending("local"));
      const savedData = await save(payroll, url, item).get("data"); 

      if (id === 'new' && savedData) {
        newDeductions = [...deductions];
        newDeductions.push(savedData);

        if (!savedData.deduction_debit_account) {
          setSettingsMessage('User needs to configure the account in the Accounts Settings.')
        }
      } else {
        history.replaceUp({
          search: `?debit_account=${savedData.deduction_debit_account || ''}`,
        });
      }

      NotificationManager.success(t("Saved successfully"));
      if (newDeductions) {
        setDeductions(newDeductions);
        setValue({
          description: "",
          amount: "",
          amount_type: "",
          amount_type_display: "",
          apply_to_allowances: [],
          apply_to_employees: [
            { name: 'Foreigner', value: false },
            { name: 'Local', value: false }
          ]
        });
      };
    } finally {
      dispatch(actions.setPending(model, false));
      dispatch(actions.setSubmitted("local"));
    }
  }

  const handleKeyUp = e => {
    if (e.target.value.trim().length == 0) e.target.value = e.target.value.trim();
  };

  if (!loaded) return null;
  return (
    <Page title={getTitle(id, "Deduction")} className="inv-table inv-tabs">
      <BackButton/>
      
      {settingsMessage && <Alert color="warning" className="mt-4 text-center">
        <h4 className="my-0"><Trans>{settingsMessage}</Trans></h4>
      </Alert>}
      
      <Form
        onSubmit={onSubmit}
        validators={{
          description: {required},
          amount: {
            required,
            isCurrency: (val) => isCurrency(val, { min: 0.01 }),
            max: (val) => {return !(val && (value.amount_type === 'PERC' && val > 100))},
          },
          amount_type: {required},
        }}
      >
        <div className="row">
          <FormGroup label="Description *" model=".description" className="col-sm pb-2 pt-2">
            <Control.text
              model=".description"
              updateOn="blur"
              placeholder="Deduction Description"
              onKeyUp={handleKeyUp}/>
            <Errors
              className="form-text small text-danger"
              model=".description"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
              }}
            />
          </FormGroup>
          <FormGroup label="Amount *" model=".amount" className="col-sm pb-2 pt-2">
            <Control.text model=".amount" updateOn="blur" onKeyUp={handleKeyUp} 
                          placeholder="Deduction amount"
            />
            <Errors
              className="form-text small text-danger"
              model=".amount"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
                isCurrency: (val) => val && t(validationMessage.MINIMUM_CURRENCY_VALUE),
                max: t(validationMessage.MAXIMUM_PERCENTAGE_VALUE),
              }}
            />
          </FormGroup>
          <FormGroup
            label="Amount Type *"
            model=".amount_type"
            addControlClass={false}
            className="col-sm pb-2 pt-2">
            <Control.text style={{backgroundColor:'#F4F7FE'}}
              placeholder="Deduction Amount Type"
              model=".amount_type"
              component={Select}
              options={amountTypesOptions.map((x) => ({value: x.id, label: x.text}))}
              simpleValue
              clearable={false}
              searchable={false}
            />
            <Errors
              className="form-text small text-danger"
              model=".amount_type"
              show="touched"
              messages={{
                required: t(validationMessage.REQUIRED),
              }}
            />
          </FormGroup>
        </div>
        <fieldset>
          <div className="row mx-1 mb-2">
            <div><Trans>Apply To</Trans></div>
            {value.apply_to_employees.map((i, indx)=>(
              <FormGroup label={i.name} className="mx-2" check key={indx}>
                <Control.checkbox model={`.apply_to_employees[${indx}].value`} />
              </FormGroup>
            ))}
          </div>
        </fieldset>
         <fieldset>
           <div className="mx-1"><Trans>Apply Deduction also To</Trans></div>
           <div className="row my-2">
            <FormGroup model=".amount" className="col-sm d-block pb-2 pt-2">
              <Multiselect 
                options={allowanceRulesOptions} // Options to display in the dropdown
                selectedValues={value.apply_to_allowances} // Preselected value to persist in dropdown
                onSelect={handleSelect} // Function will trigger on select event
                onRemove={handleRemove} // Function will trigger on remove event
                displayValue="description" // Property name to display in the dropdown options
                closeOnSelect
                avoidHighlightFirstOption
                showCheckbox={true}
                style={multiSelectStyle}
                placeholder={t("Select")}
                emptyRecordMsg={t('No options available')}
              />
            </FormGroup>
           </div>
         </fieldset>
        <div className="mb-5">
        <SubmitButton className="btn-nxt">{id === 'new'? t("Add") : t("Save")}</SubmitButton>
        </div>
        {id === 'new' && deductions.length > 0 && (<hr/>)}
      </Form>
      {id === 'new' && deductions.length > 0 && (<Table size="sm" className="no-wrap v-middle text-center" responsive>
        <thead>
        <tr>
          <th className="text-nowrap">
            <Trans>Description</Trans>
          </th>
          <th className="text-nowrap">
            <Trans>Amount</Trans>
          </th>
          <th className="text-nowrap">
            <Trans>Amount Type</Trans>
          </th>
          <th></th></tr>
        </thead>
        <tbody>
        {deductions.map((i, idx) => (
          <tr key={i.id}>
            <td>
              {i.description}
            </td>
            <td>
              {i.amount}
            </td>
            <td>
              {i.amount_type_display}
            </td>
            <td className="text-right">
              <PendingButton
                size="sm"
                color="link"
                onClick={() => {
                  onDeleteItem(i.id);
                }}
              >
                <span className="fa fa-trash text-danger"/>
              </PendingButton>
            </td>
          </tr>
        ))}
        </tbody>
      </Table>)}

      <hr />

      <HistoryAndNotes
        item={value}
        contentType={'deductionrules'}
        client={client}
        t={t}
      />
    </Page>
  );
};

export default EditDeduction;
